<div class="profile-container">

  <ng-container *ngIf="isLoading ; else forms">
    <app-shimmer-loader [pagination]="false" type="profileCardShimmer" [image]="true" [showThirdLine]="true"
      [cardsCount]="3">
    </app-shimmer-loader>
  </ng-container>

  <ng-template #forms>
    <ng-container *ngIf="profileConfig">
      <div class="profile-header">
        <h3>{{ profileConfig.title || 'Profile' }}</h3>
      </div>

      <div class="profile-content">
        <!-- User Info Section -->
        <div class="user-info-section" *ngIf="profileConfig.user">
          <div class="user-avatar">
            <img [src]="avatarObjUrl || profileConfig.user.avatar || './assets/Images/default-avatar.png'"
              [alt]="profileConfig.user.name" class="avatar-image" (error)="onImageError($event)">
          </div>
          <div class="user-details">
            <h3 class="user-name">{{ profileConfig.user.name }}</h3>
            <div class="contact-info">
              <div class="info-item" *ngFor="let key of getUserInfoKeys()">
                <span class="label">{{ toTitleCase(key) }}</span>
                <span class="value">{{ profileConfig.user[key] }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Account Manager Section: hide for Individual profiles -->
        <div class="section-card" [hidden]="true">
          <!-- <div class="section-card" *ngIf="profileConfig.levels && showlevels"> -->
          <div class="section-header">
            <h4>{{ profileConfig.levels.title }}</h4>
            <mat-icon *ngIf="profileConfig.levels.icon" matTooltip="No info available right now">{{
              profileConfig.levels.icon }}</mat-icon>
          </div>
          <div class="section-content">
            <div class="content-with-button">
              <div class="activity-grid">
                <div class="activity-item">
                  <span class="activity-label">{{ profileConfig.levels.currentLabel }}</span>
                  <span class="activity-value">{{ profileConfig.levels.currentManager }}</span>
                </div>
                <div class="activity-item">
                  <span class="activity-label">{{ profileConfig.levels.tinLabel }}</span>
                  <span class="activity-value">{{ profileConfig.levels.managerTin }}</span>
                </div>
              </div>
              <!-- <button mat-raised-button color="primary" class="action-button" *ngIf="profileConfig.levels.actionButton">
                <mat-icon class="action-icon">{{ profileConfig.levels.actionButton.icon }}</mat-icon>
                {{ profileConfig.levels.actionButton.text }}
              </button> -->
            </div>
          </div>
        </div>

        <!-- Activity Log Section -->
        <div class="section-card" *ngIf="profileConfig.recentActivity">
          <div class="section-header">
            <h4>{{ profileConfig.recentActivity?.title || 'Activity Log' }}</h4>
          </div>
          <div class="section-content">
            <div class="activity-grid">
              <div class="activity-item" *ngFor="let activity of profileConfig.recentActivity.activities">
                <span class="activity-label">{{ activity.label }}</span>
                <span class="activity-value">{{ activity.value }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>

  <div class="no-data dataUnavailable" *ngIf="!profileConfig && !isLoading">
    <app-data-unavailable [content]="'Unable to load User information.'"></app-data-unavailable>
  </div>
</div>